var _path, _path2;
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Rocket = function Rocket(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'tw-text-neutral-light-800' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsxs("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: [_path || (_path = /*#__PURE__*/_jsx("path", {
      d: "M15 7a2 2 0 1 0 0 4 2 2 0 0 0 0-4Z",
      fill: "none",
      className: "tw-fill-current"
    })), _path2 || (_path2 = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16.946 3.001a4 4 0 0 1 4.053 4.053 10 10 0 0 1-6.054 8.65 6.999 6.999 0 0 1-3.446 5.162 1 1 0 0 1-1.492-.748 7 7 0 0 0-.24-1.161 7.003 7.003 0 0 1-5.896 2.035 1 1 0 0 1-.863-.863 7 7 0 0 1 2.035-5.897 7.008 7.008 0 0 0-1.14-.236 1 1 0 0 1-.757-1.516 7 7 0 0 1 5.15-3.425 10 10 0 0 1 8.65-6.054Zm-8.94 12.993c.304.305.579.636.82.987a5 5 0 0 1-3.873 2.066 5 5 0 0 1 2.066-3.873c.351.241.682.516.987.82Zm-2.24-3.633a9 9 0 0 1 5.873 5.874A4.993 4.993 0 0 0 13 14.967a1 1 0 0 1 .667-.91A8 8 0 0 0 19 6.975 2 2 0 0 0 17.025 5a8 8 0 0 0-7.082 5.332 1 1 0 0 1-.91.667 4.999 4.999 0 0 0-3.268 1.362Z",
      fill: "none",
      className: "tw-fill-current"
    }))]
  });
};
export default Rocket;